module.exports = __webpack_public_path__ + "static/media/ico_channel.e2f1ff62.svg";